export default "__VITE_ASSET__Bv6dbeaV__"